import { useState } from "react"
import { Pencil, XIcon} from "lucide-react"
import { usePage } from "@inertiajs/react"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { Button } from "./ui/button"

type DocumentClassifier = {
  name: string
}

type PageProps = {
  document_classifiers: DocumentClassifier[]
}

type Props = {
  fax_classifier?: string | null,
  onChange?: (name: string | null) => void
}

export default function DocumentClassifierSelect({
  fax_classifier,
  onChange,
}: Props) {
  const { props } = usePage<PageProps>()
  const { document_classifiers } = props

  const [editing, setEditing] = useState(false)

  if (!editing) {
    return (
      <div
        className="group flex items-center gap-2 min-w-[180px] cursor-pointer"
        onClick={
          (e) => {
            e.preventDefault()
            e.stopPropagation()

            setEditing(true)
          }

        }
      >
        <span className="truncate text-sm">
          {fax_classifier || "Unclassified"}
        </span>

        <Pencil
          className="h-3 w-3 text-muted-foreground "
        />
      </div>
    )
  }

  return (
    <div className="flex items-center ">
      <Select
        value={fax_classifier ?? undefined}
        onValueChange={(v) => {
          onChange?.(v || null)
          setEditing(false)
        }}
      >
        <SelectTrigger className="h-8">
          <SelectValue placeholder="Unclassified" />
        </SelectTrigger>

        <SelectContent>
          {document_classifiers?.map((dc) => (
            <SelectItem key={dc.name} value={dc.name}>
              {dc.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Button
        variant="ghost"
        size="icon"
        className="ml-2 h-8 w-8"
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()

          setEditing(false)
        }}
      ><XIcon className="text-red-300"/></Button>
    </div>
  )
}

